const classEvaluationDetails = {
  path: 'classEvaluationDetails/:classEvaluationId',
  component: resolve => require(['../../../../components/pages/student_user/classEvaluationDetails'], resolve),
  props: true
}
export default classEvaluationDetails
